import { __assign } from "tslib";
// DS: I53
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
var Burger = function (props) { return (React.createElement(IconWrap, __assign({}, props),
    React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
        React.createElement("g", null,
            React.createElement("path", { d: "M6 4h12v3H6zM6 18h12v3H6zM2 11h20v3H2z" }))))); };
Burger.displayName = 'Burger';
export default Burger;
//# sourceMappingURL=Burger.js.map